import React, { Component } from "react";
import { Link } from "react-router-dom";
import { withRouter } from "react-router";
import { Spin,message } from "antd"


import RightImageComponent from './right_image_component'
import AuthFooterComponent from './footer_component'
import AppService from '../../service/app_service';

class ForgotPasswordPage extends Component {

  constructor(props) {
    super(props);
    this.state = {
      dashboard: props.dashboard,
      loading: false,
    };
  }


  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value
    });

  }

  passwordReset = () => {
    this.setState({ loading: true });

    AppService.passwordReset(this.state).then(rec => {
      if (rec) {
        if (rec.code === "400") {
          message.error(rec.message);
          this.setState({ loading: false });
        } else {
          message.success("An email has been sent to you.")
          this.props.history.push("/signin");
        }
      } else {
        alert("Empty response")
      }
    })



  }

  render() {

    const { loading } = this.state;

    return (
      <div className="page-ath-wrap">
        <div className="page-ath-content">
          <div className="page-ath-header"><a href="/" className="page-ath-logo"><img src="/assets/images/logo.png" srcSet="/assets/images/logo2x.png 2x" alt="logo" /></a></div>
          
          <Spin spinning={loading}>
            <div className="page-ath-form">
              <h2 className="page-ath-heading">Reset password <span>If you forgot your password, well, then we’ll email you instructions to reset your password.</span></h2>
              <form action="#" onSubmit={e => e.preventDefault()}>
                <div className="input-item"><input type="text" onChange={this.handleChange} name="username" placeholder="Your username" className="input-bordered" /></div>
                <div className="d-flex justify-content-between align-items-center">
                  <div><button className="btn btn-primary btn-block" onClick={this.passwordReset} >Send Reset Link</button></div>
                  <div><Link to="/signin">Return to login</Link></div>
                </div>
                <div className="gaps-2x" />
              </form>
            </div>
          </Spin>


          <AuthFooterComponent />
        </div>
        <RightImageComponent />
      </div>
    );
  }
}

export default withRouter(ForgotPasswordPage);
